var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pco-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"forms"},[(_vm.forms.length > 0)?_vm._l((_vm.forms),function(form){return _c('app-form-card',{key:form._id,staticClass:"form",attrs:{"id":form._id,"name":form.name,"startDate":form.startDate,"endDate":form.endDate,"answered":form.answered}})}):_c('div',{style:({
            textTransform: 'uppercase',
            letterSpacing: '.1rem',
            opacity: 0.8,
            textAlign: 'center'
          })},[_vm._v(" Nenhum novo form ")])],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }